module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "roomsblock"
  }, [(_vm.date.length) ? _c('p', {
    staticClass: "roomsblock__date"
  }, [_vm._v(_vm._s(_vm.dateText) + " " + _vm._s(_vm.date) + " года")]) : _c('p', {
    staticClass: "roomsblock__date"
  }, [_vm._v("Дата не определена.")]), _c('a', {
    staticClass: "roomsblock__link",
    class: {
      roomsblock__link_grey: !_vm.linkData[this.link_state].isActive
    },
    attrs: {
      "target": "_blank",
      "href": _vm.linkData[this.link_state].url
    }
  }, [_vm._v(_vm._s(_vm.linkData[this.link_state].text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02057dca","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/info/components/block/components/legend/components/roomsblock/RoomsBlock.vue
// module id = 32d60fe2c66318c4602b
// module chunks = 89